import { createWebHistory, createRouter } from "vue-router";
import LoginView from "../views/auth/login.vue";
import RegisterView from "../views/auth/register.vue";
import VerifyOTPView from "../views/auth/verify-otp.vue";
import DashboardView from "../views/dashboard/dashboard-view.vue";
import ReleasedProduct from "../views/released-product/relased-product.vue";
import UserManagement from "../views/user-management/user-management.vue";
import ForgotPassword from "../views/auth/forgot-password.vue";
import { useAuthStore } from "@/store/auth_store";
import ResetPassword from "../views/auth/reset-password.vue";
import ViewProductDetail from "@/views/released-product/view-product-detail.vue";
import ProductCertificates from "@/views/products-certificates/product-certificates.vue";

const routes = [
  {
    path: "/",
    name: "login",
    component: LoginView,
  },
  {
    path: "/register",
    name: "register",
    component: RegisterView,
  },
  {
    path: "/verify-otp",
    name: "verify-otp",
    component: VerifyOTPView,
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: DashboardView,
    meta: { requiresAuth: true },
  },
  {
    path: "/released-product",
    name: "released-product",
    component: ReleasedProduct,
    meta: { requiresAuth: true },
  },
  // {
  //     path: '/view-release-doc',
  //     name: 'view-release-doc',
  //     component: ViewReleaseDoc
  // },
  {
    path: "/user-management",
    name: "user-management",
    component: UserManagement,
    meta: { requiresAuth: true },
  },
  {
    path: "/product-certificates",
    name: "product-certificates",
    component: ProductCertificates,
    meta: { requiresAuth: true },
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: ForgotPassword,
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: ResetPassword,
  },
  {
    path: "/view-product",
    name: "view-product",
    component: ViewProductDetail,
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to) => {
  document.title = to.meta?.title ?? "Version Vault";
  const publicPages = [
    "/",
    "/register",
    "/verify-otp",
    "/forgot-password",
    "/reset-password",
  ];
  const authRequired = !publicPages.includes(to.path);
  const auth = useAuthStore();

  if (authRequired && !auth.logged_in_user) {
    auth.returnUrl = to.fullPath;
    return "/";
  }
});

export default router;
